import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es7.object.values";
import _defineProperty from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/defineProperty";
import "core-js/modules/es6.regexp.split";
import "core-js/modules/web.dom.iterable";
import _toConsumableArray from "D:/zlwl/portal/node_modules/@babel/runtime/helpers/esm/toConsumableArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateConfig, listConfig, getNetworkInfo } from "@/api/configurationlist";
import { getProgressStatus, progressControl } from "@/api/particulars";
import Opv from "./components/opv.vue";
import { cloneDeep } from "lodash";
export default {
  name: "openvpn",
  props: ["deviceSn", "deviceDid", "deviceSoftwareVer"],
  data: function data() {
    return {
      opvList: [],
      statusData: {},
      opvData: {},
      timer: null,
      loading: false
    };
  },
  methods: {
    getConfig: function getConfig() {
      var _this = this;

      return new Promise(function (reslove, reject) {
        var options = [{
          option: "nobind"
        }, {
          option: "verb"
        }, {
          option: "comp_lzo"
        }, {
          option: "client"
        }, {
          option: "proto"
        }, {
          option: "port"
        }, {
          option: "keepalive"
        }, {
          option: "cipher"
        }, {
          option: "nice"
        }, {
          option: "dev_type"
        }, {
          option: "server"
        }, {
          option: "server_bridge"
        }, {
          option: "compress"
        }, {
          option: "auth_method"
        }, {
          option: "enabled"
        }, {
          option: "tun_ipv6"
        }, {
          option: "username"
        }, {
          option: "password"
        }, {
          option: "recipe"
        }, {
          option: "ca"
        }, {
          option: "key"
        }, {
          option: "cert"
        }, {
          option: "username"
        }, {
          option: "password"
        }, {
          option: "comp_lzo"
        }, {
          option: "nice"
        }, {
          option: "dev_type"
        }, {
          option: "secret"
        }, {
          option: "pkcs12"
        }, {
          option: "dh"
        }, {
          option: "tls_crypt"
        }, {
          option: "remote"
        }];

        if (_this.deviceSoftwareVer >= "v2.5.221125") {
          options = [].concat(_toConsumableArray(options), [{
            option: "auth"
          }, {
            option: "enable_secret"
          }, {
            option: "enable_tls_auth"
          }, {
            option: "enable_tls_crypt"
          }, {
            option: "enable_dh"
          }, {
            option: "enable_pkcs12"
          }, {
            option: "dev"
          }, {
            option: "tls_auth"
          }]);
        }

        listConfig(_this.deviceSn, _this.deviceDid, [{
          section: "openvpn",
          config: "openvpn",
          options: options,
          lists: [{
            list: "remote"
          }]
        }]).then(function (res) {
          res.data.data.mess[0].s_objects.forEach(function (v) {
            if (v.lists.remote.length !== 0) {
              v.options.remote += v.lists.remote.join(" ");
            }

            v.options.remote = v.options.remote.split(" ");
            if (!v.options.proto) v.options.proto = "udp";
            _this.opvList = [_objectSpread(_objectSpread({}, v.options), {}, {
              // ...v.lists,
              sname: v.sname
            })].map(function (v, index) {
              if (_this.opvList.length > 0) {
                v.ovpn_constatus = _this.opvList[index].ovpn_constatus;
                return v;
              } else {
                return v;
              }
            });
          });
          getProgressStatus(_this.deviceDid, _this.deviceSn, {
            process: ["openvpn"]
          }).then(function (res) {
            _this.opvList = _this.opvList.map(function (v) {
              v.status = res.data.data.mess[0].status;

              if (v.status == 0) {
                v.ovpn_constatus = _this.$t("lang.openvpn.noConnect");
              } else {
                v.ovpn_constatus = res.data.data.mess[0].ovpn_constatus ? res.data.data.mess[0].ovpn_constatus : _this.$t("lang.openvpn.connecting");
              }

              v.client = v.client == 1 ? true : false;
              v.enabled = v.enabled == 1 ? true : false;
              v.nobind = v.nobind == 1 ? true : false;
              v.tun_ipv6 = v.tun_ipv6 == 1 ? true : false;
              v.auth_method = v.auth_method ? v.auth_method : "ca cert";
              v.cipher = v.cipher ? v.cipher : "AES-128-CBC";
              return v;
            });
            _this.statusData = res.data.data.mess[0];
            reslove();
          });
        });
      });
    },
    editClick: function editClick(e) {
      this.opvData = e.row;
      this.$refs["opv"].opvDialog = true;
    },
    update: function update(e, v) {
      var _this2 = this;

      this.loading = true;
      var write_files = Object.values(e).filter(function (v) {
        return v.content;
      });

      var options = function (e) {
        var data = {};
        e.forEach(function (v) {
          data[v.file_name.slice(v.file_name.lastIndexOf(".") + 1)] = v.file_name;
        });
        return data;
      }(write_files);

      var opvList = [v].map(function (v) {
        var obj = cloneDeep(v);
        delete obj.status;
        delete obj.sname;
        delete obj.ovpn_constatus;
        console.log(obj.remote);
        obj.remote = obj.remote.join(" ");
        obj.client = obj.client ? 1 : 0;
        obj.enabled = obj.enabled ? 1 : 0;
        obj.nobind = obj.nobind ? 1 : 0;
        obj.tun_ipv6 = obj.tun_ipv6 ? 1 : 0;
        return obj;
      });
      options = _objectSpread(_objectSpread({}, opvList[0]), options);
      updateConfig(this.deviceSn, this.deviceDid, [{
        section: "openvpn",
        config: "openvpn",
        sname: "opv1",
        index: [0],
        action: 0,
        options: options,
        write_files: write_files
      }]).then( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(res) {
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (res.data.data.mess === 0) {
                    _this2.$message({
                      showClose: true,
                      message: _this2.$t("lang.ConfigSetting.Successfulconfiguration"),
                      type: "success"
                    });
                  } else {
                    _this2.$message({
                      showClose: true,
                      message: _this2.$t("lang.ConfigSetting.Configurationerror"),
                      type: "warning"
                    });
                  }

                  _context.next = 3;
                  return _this2.restart();

                case 3:
                  _context.next = 5;
                  return _this2.getConfig();

                case 5:
                  _this2.loading = false;

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    start: function start() {
      var _this3 = this;

      progressControl([{
        process: "openvpn",
        action: "start",
        type: 0
      }], String(this.deviceDid), this.deviceSn).then( /*#__PURE__*/function () {
        var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(res) {
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  _this3.loading = true;

                  _this3.$message({
                    message: _this3.$t("lang.openvpn.actionOk"),
                    type: "success",
                    showClose: true
                  });

                  _context2.next = 4;
                  return _this3.getConfig();

                case 4:
                  _this3.loading = false;

                case 5:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x2) {
          return _ref2.apply(this, arguments);
        };
      }());
    },
    stop: function stop() {
      var _this4 = this;

      progressControl([{
        process: "openvpn",
        action: "stop",
        type: 0
      }], String(this.deviceDid), this.deviceSn).then( /*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(res) {
          return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
              switch (_context3.prev = _context3.next) {
                case 0:
                  _this4.loading = true;

                  _this4.$message({
                    message: _this4.$t("lang.openvpn.stopOk"),
                    type: "success",
                    showClose: true
                  });

                  _context3.next = 4;
                  return _this4.getConfig();

                case 4:
                  _this4.loading = false;

                case 5:
                case "end":
                  return _context3.stop();
              }
            }
          }, _callee3);
        }));

        return function (_x3) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    restart: function restart() {
      var _this5 = this;

      return new Promise(function (reslove, reject) {
        progressControl([{
          process: "openvpn",
          action: "restart",
          type: 0
        }], String(_this5.deviceDid), _this5.deviceSn).then(function (res) {
          reslove();
        });
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;

    if (!this.timer) {
      this.timer = setInterval(function () {
        _this6.getConfig();
      }, 10000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  watch: {
    deviceSn: {
      handler: function () {
        var _handler = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(newV) {
          return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
              switch (_context4.prev = _context4.next) {
                case 0:
                  this.loading = true;
                  _context4.next = 3;
                  return this.getConfig();

                case 3:
                  this.loading = false;

                case 4:
                case "end":
                  return _context4.stop();
              }
            }
          }, _callee4, this);
        }));

        function handler(_x4) {
          return _handler.apply(this, arguments);
        }

        return handler;
      }(),
      immediate: true
    }
  },
  components: {
    Opv: Opv
  }
};